import { render, staticRenderFns } from "./TreatmentAddons.vue?vue&type=template&id=133d62df"
import script from "./TreatmentAddons.vue?vue&type=script&lang=js"
export * from "./TreatmentAddons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports